module.exports = __webpack_public_path__ + "img/vvip-onboarding-title.83a27bf4.webp";